import styled from 'styled-components'

import AutoTable from 'components/AutoTable'
import Button from 'components/Button/Button'
import { themeGet } from 'styled-system'

export const UploadButton = styled(Button)`
  background-color: #002855;
`
export const Instructions = styled.span`
  display: flex;
  font-family: Molde-Regular;
  padding: 0.6rem 0;
`
export const ExampleImage = styled.img`
  display: flex;
  width: 100%;
`
export const UploadSection = styled.div`
  display: flex;
  padding: 0.5rem 0;
  align-items: center;
`

export const Required = styled.span`
  color: red;
`

export const ResultsSection = styled.div`
  margin: 1rem 0rem;
  max-height: 500px;
  overflow-y: auto;

  & a {
    color: ${themeGet('colors.blue')};
  }

  & a:hover {
    color: ${themeGet('colors.darkBlue')};
  }
`

export const StyledAutoTable = styled(AutoTable)`
  margin-top: 1rem;
`

export const TemplateLinkWrapper = styled.div`
  a {
    color: ${themeGet('colors.blue')};
  }
`

export const FieldDescriptionList = styled.ul`
  list-style: none;
  padding-left: 0;
  margin: 1rem 0;
`

export const FieldDescriptionItem = styled.li`
  margin-bottom: 0.75rem;
  line-height: 1.5;
`

export const FieldName = styled.span`
  font-weight: 600;
  font-family: Molde-Semibold;
  margin-right: 0.5rem;
`

export const FieldDescription = styled.span`
  font-weight: 400;
  font-family: Molde-Regular;
`
